var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { DeskPool } from '../../DeskPool';
import { endPlayerIntroduction } from '../../../../api';
import { useAppDispatch, useAppSelector, useQuery } from '../../../../hooks';
import { selectMatchState, setMatchState } from '../../../../store/match';
import { useErrorHandler } from '../../../../hooks/useErrorHandler';
export function PlayerIntroducing() {
    var _a;
    const { param: matchId } = useQuery('matchId');
    const { errorHandler } = useErrorHandler(matchId);
    const matchState = useAppSelector(selectMatchState);
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const onGameButtonClick = () => __awaiter(this, void 0, void 0, function* () {
        var _b;
        // console.log('StartIntroduction onGameButtonClick')
        setIsLoading(true);
        try {
            const result = yield endPlayerIntroduction((_b = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _b === void 0 ? void 0 : _b.introductionId);
            console.log('EndPlayerIntroduction', result);
            dispatch(setMatchState(result));
        }
        catch (err) {
            errorHandler(err);
            console.error('EndPlayerIntroduction error', err.response);
        }
        finally {
            setIsLoading(false);
        }
    });
    const currentPlayer = (_a = matchState === null || matchState === void 0 ? void 0 : matchState.players) === null || _a === void 0 ? void 0 : _a.find((p) => { var _a; return p.id === ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentPlayer); });
    const gameButtonState = {
        text: isLoading ? 'Выполняется...' : `${currentPlayer === null || currentPlayer === void 0 ? void 0 : currentPlayer.player.gameName} закончил(а)`,
        visible: true,
        onClick: onGameButtonClick,
        disabled: isLoading,
    };
    return (_jsx(DeskPool, { onPlayerClickAction: null, gameButtonState: gameButtonState }));
}
